import React from "react";

import "./ThankYou.css";

const ThankYou = (props) => {
  return (
    <div className="body-content">
      <img src={require("./logo.png")} alt="logo" />{" "}
      <div className="thank-page-body">
        <h2>Thanks {props.name}, your response has been recorded</h2>
        <h6>You can safely close this window</h6>
      </div>
    </div>
  );
};

export default ThankYou;
